var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 43 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#015D59",
  d: "M8.572 4.59h11.69a3.215 3.215 0 0 1 3.246 3.248 3.215 3.215 0 0 1-3.247 3.247h-5.195c-1.039 0-1.948.909-1.948 1.948s.909 1.948 1.948 1.948h8.312c.52 0 1.04-.26 1.429-.52L36.886 1.733c1.429-1.429 3.766-1.429 5.065 0l.26.26c1.169 1.558 1.039 3.637-.39 4.935L28.054 20.306c-.65.65-1.558 1.039-2.598 1.039H8.442A8.425 8.425 0 0 1 0 12.903C0 8.227 3.896 4.59 8.572 4.59"
})));
export default SvgHand;